module.exports = __webpack_public_path__ + "img/riddlr-thumbnail.434cbcf4.png";